import {
  OBSERVADOR_INICIALITZAR,
  OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS,
  OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS
} from "../../../actions/actionTypes";

const ESTAT_INICIAL = false;

const mostrarErrors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case OBSERVADOR_INICIALITZAR:
    case OBSERVADOR_INTRODUCCIO_DESCARTAR_CANVIS:
      return ESTAT_INICIAL;

    case OBSERVADOR_INTRODUCCIO_MOSTRAR_ERRORS:
      return true;

    default:
      return state;
  }
};

export default mostrarErrors;
